import { render, staticRenderFns } from "./user-identification-wrapper.vue?vue&type=template&id=229a7ac4&scoped=true"
import script from "./user-identification-wrapper.vue?vue&type=script&lang=js"
export * from "./user-identification-wrapper.vue?vue&type=script&lang=js"
import style0 from "./user-identification-wrapper.vue?vue&type=style&index=0&id=229a7ac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229a7ac4",
  null
  
)

export default component.exports